module.exports = __webpack_public_path__ + "img/avatar.f1b50d0c.png";